import { resolveConsent } from "./resolveConsent";

const GTM_SERVICE_NAME = "Google Tag Manager";

type ConsentListener = () => void;

let consent: boolean | null = null;
let initialized = false;
const listeners = new Set<ConsentListener>();

function setConsent(value: boolean | null) {
  if (value === consent) return;
  consent = value;
  listeners.forEach((listener) => listener());
}

async function resolveGtmConsent() {
  setConsent(await resolveConsent(GTM_SERVICE_NAME));
}

function ensureInitialized() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  if (window.UC_UI) {
    resolveGtmConsent();
  } else {
    window.addEventListener("UC_UI_INITIALIZED", resolveGtmConsent);
  }
  window.addEventListener("UC_UI_UPDATE", resolveGtmConsent);
  window.addEventListener("UC_UI_CMP_EVENT", resolveGtmConsent);
}

/**
 * Tri-state Usercentrics consent for the "Google Tag Manager" service:
 * true (granted) | false (explicitly declined) | null (not yet resolved).
 */
export function getGtmConsent(): boolean | null {
  ensureInitialized();
  return consent;
}

export function subscribeToGtmConsent(listener: ConsentListener): () => void {
  ensureInitialized();
  listeners.add(listener);
  return () => listeners.delete(listener);
}
